/**
 * Language : Spanish
 */
export default {
    time: {
        openingHoursTitle: "Horario de apertura",
        at: "a las",
        to: "a",
        opensToday: "Abierto hoy",
        opens: "Abierto",
        open24_7: "Abierto las 24 horas",
        closed: "Cerrado",
        openUntil: "Abierto hoy hasta las",
        daily: "Abierto todos los días de",
        month: [
            'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ],
        monthAbbr: [
            'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
            'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
        ],
        dayOfWeek: [
            'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo', 
        ],
        dayOfWeekAbbr: [
            'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom', 
        ],
        temporarilyClosed: "Cerrado temporalmente",
        opened: "",
        today: ""
    },
    search: {
        placeholder: "Calle, ciudad o código postal",
        submitLabel: "Buscar",
        clearLabel: "Borrar búsqueda",
        yourLocation: "Tu ubicación",
    },
    filtering: {
        servicesTitle: "Servicios",
        services: {
            WF: 'Punto de acceso inalámbrico',
            CD: 'Pago móvil',
            DT: 'Drive-Thru',
            DR: 'Recompensas Digitales',
            hrs24: 'Abierto las 24 horas al día',
            WA: 'Comida calentada en horno',
            LB: 'LaBoulange',
            XO: 'Pedido y Pago Móvil',
            VS: 'Verismo',
            NB: 'Nitro Cold Brew',
            CL: 'Starbucks Reserve-Café Clover Brewed',
        }
    },
    stores: {
        cta: {
            call: "Llamar",
            directions: "Indicaciones",
            website: "Sitio web",
            'club details': 'Más detalles',
            'view tariffs': 'Inscríbete',
            'View Map': "Ver mapa",
            'View List': "Ver lista"
        },
        messages: {
            initialHeader: "Comienza buscando una ubicación para mostrar gimnasios cercanos",
            emptyHeader: "No se encontró ningún gimnasio",
            initialBody: "o haz clic en el mapa para seleccionar un gimnasio",
            emptyBody: "Por favor, busca en una ubicación diferente o desactiva tus filtros"
        }
    },
    directions: {
        avoidOptions: {
            highways: 'Autopistas',
            tolls: 'Peajes',
            ferries: 'Ferries'
        },
        unitOptions: {
            METRIC: 'km',
            IMPERIAL: 'millas'
        },
        options: "Opciones de ruta",
        avoid: "Evitar",
        units: "Unidades de distancia",
        messages: {
            initialBody: "Busca un origen y destino para ver rutas disponibles y tiempos de viaje.",
            error: "Lo sentimos, no pudimos calcular las indicaciones para conducir",
            from: "desde",
            to: "hasta",
            forTravelMode: "para el modo de viaje",
            via: "a través de",
            details: "Detalles",
            withoutTraffic: "sin tráfico",
            openGoogleMaps: "abrir en Google Maps"
        }
    },
    errors: {
        loadingLibrary: "Error al cargar el script de {library}",
        geolocationFailed: "Error en la geolocalización del usuario",
        apiErrors:{
            "401": "No autorizado",
            "403": "Prohibido",
            "429": "Demasiadas solicitudes",
            "500": "Error interno del servidor",
            other: "Se produjo un error inesperado del servidor"
        }
    },
};